import React, { useEffect, useState } from 'react';
import { 
  Box, 
  CircularProgress, 
  Typography 
} from '@mui/material';
import { 
  Error as ErrorIcon 
} from '@mui/icons-material';
import { 
  useLocation, 
  useNavigate, 
  useOutletContext 
} from 'react-router-dom';
import { authLineLogin, register } from '../../api/api';
import { OutletContextType } from '../root';


/**
 * 【TKG_RESERVE_0100】
 * ログイン後のコールバックを受け取る画面
 */
export const CallbackReceive = () => {
  const { setUserId, setUserName, setPictureUrl } = useOutletContext<OutletContextType>();

  // ローディング状態を管理
  const [isLoading, setIsLoading] = useState(true);

  // navigateを作成
  const navigate = useNavigate();

  // 現在のlocationオブジェクトを取得
  const location = useLocation();

  // location.searchは "?authorization_code=xxxx" のようなクエリ部分
  const queryParams = new URLSearchParams(location.search);

  // "authorization_code" パラメータを取得
  const authorizationCode = queryParams.get('authorization_code');
  console.log("authorization_code", authorizationCode);

  // ログイン処理
  useEffect(() => {
    if (authorizationCode) {
      // 認証中
      authLineLogin(authorizationCode).then(response => {
        console.log("認証結果", response);

        setUserId(response.userId);
        setUserName(response.displayName);
        setPictureUrl(response.pictureUrl);

        if (response.isRegistered) {
          // 既に登録済みのユーザーであった場合、イベント一覧画面へ遷移
          const params = {
            user_id: response.userId,
          };
          navigate('/portal', { state: params });
        } else {
          // 未登録のユーザーであった場合、ユーザーマスタ登録処理を実行
          register(response.userId, response.displayName, response.pictureUrl).then(() => {
            navigate('/awaiting-approval');
          });
        }
      }).catch(error => {
        console.error('Error during login', error);
        // ログイン処理でエラーが発生した場合もローディングを解除
        setIsLoading(false);
      });
    } else {
      console.error('No authorization code found');
      setIsLoading(false);
    }
  }, [authorizationCode, navigate, setUserId, setUserName, setPictureUrl]);

  // ローディング画面表示
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#FFFBF0',
          padding: 3,
          borderRadius: 2,
        }}
      >
        {/* ローディングアイコン */}
        <CircularProgress
          sx={{
            color: '#FF7043',
            size: 60,
            marginBottom: 2,
          }}
        />

        {/* 認証中のメッセージ */}
        <Typography
          variant="h5"
          sx={{
            color: '#FF7043',
            fontWeight: 'bold',
            fontSize: '1.2rem',
            textAlign: 'center',
          }}
        >
          認証中です...
        </Typography>
      </Box>
    );
  }

  return (
    // 画面遷移しない時に表示される内容（エラーなど）
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '50vh',
        textAlign: 'center',
        padding: '15vh'
      }}
    >
      <Typography
        sx={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          color: '#fff',
          backgroundColor: '#f44336',
          padding: '10px',
          borderRadius: '5px',
        }}
      >
        <ErrorIcon sx={{ marginRight: '8px' }} />
        データが読み込めません。お手数ですが最初からやりなおしてください。<br/>
        この事象が解決しない場合は、管理者へお問合せをお願いいたします。
      </Typography>
    </Box>
  );
};

